/* raw layout hash: _noc-fleet-monitoring-alarms-layout:feb8ea771e29ad7b34e49b9d97dec2369ba0eef4d633df00586e8c30a284a3a5 */
import React from 'react';
import AppShell from './AppShell.jsx';

// Raw layout: _noc-fleet-monitoring-alarms-layout.html — top navbar + mobile bottom bar. Menu entries are role-based (see AppShell / menuData.js).

export default function NocFleetMonitoringAlarmsLayout() {
  return <AppShell />;
}
